import {
  ChevronUp,
  Edit,
  PlusCircle,
  Trash2,
  RotateCcw,
  Eye,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import { getAllUsers } from "../../core/api/settings.js";
import EditPermission from "./editPermission.jsx";
// import { message } from "antd";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { deleteUser } from "../../core/api/settings";

const UsersList = () => {
  const dispatch = useDispatch();
  // const MySwal = withReactContent(Swal); // Not used after refactoring

  // Header toggle (from redux)
  const data = useSelector((state) => state.toggle_header);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isRightSideBarVisible, setIsRightSideBarVisible] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [sidebarWidth, setSidebarWidth] = useState(0);
  // const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  // Get current user role from Redux profile instead of sessionStorage (more reliable)
  const profile = useSelector((state) => state.profile);
  const currentUserRole = profile?.role || sessionStorage.getItem("user_role");
  const [resetFormTrigger, setResetFormTrigger] = useState(0);

  // Removed unused toggleSidebarEditMode function

  // Removed unused handleCloseSidebar function

  // Search
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  // Fetch users
  const loadUsers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getAllUsers();
      const all = response.data || [];
      const filtered =
        currentUserRole === "super_admin"
          ? all
          : all.filter((user) => user.role !== "super_admin");
      setUsers(filtered);
      setFilteredUsers(filtered);
    } catch (err) {
      console.error(err);
      setUsers([]);
      setFilteredUsers([]);
    }
    setLoading(false);
  }, [currentUserRole]);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  // Responsive sidebar
  const sidebarRef = useRef(null);
  useEffect(() => {
    const updateSidebarWidth = () => {
      if (sidebarRef.current) {
        setSidebarWidth(sidebarRef.current.getBoundingClientRect().width);
      }
    };
    if (isRightSideBarVisible) {
      updateSidebarWidth();
      window.addEventListener("resize", updateSidebarWidth);
    }
    return () => {
      window.removeEventListener("resize", updateSidebarWidth);
    };
  }, [isRightSideBarVisible]);

  // Removed unused showConfirmationAlert function

  // Table columns
  const columns = [
    {
      title: "Username",
      dataIndex: "username",
      render: (text) => (
        <span className="productimgname">
          <span
            className="clickable-link"
            onClick={() => {
              setCurrentUserId(null);
              setResetFormTrigger((prev) => prev + 1);
              setIsRightSideBarVisible(true);
            }}>
            <u>{text}</u>
          </span>
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (text) => (
        <span
          className={`badge ${
            text === "super_admin"
              ? "bg-info"
              : text === "admin"
              ? "bg-success"
              : "bg-warning"
          } px-3 py-2`}
          style={{ fontSize: "0.98rem" }}>
          {text.charAt(0).toUpperCase() + text.slice(1)}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <div className="action-table-data" style={{ float: "left" }}>
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              title="View"
              onClick={() => {
                setCurrentUserId(record.id);
                setIsRightSideBarVisible(true);
                setIsViewMode(true);
              }}>
              <Eye className="feather-view" />
            </Link>
            <Link
              className="me-2 p-2"
              title="Edit"
              onClick={() => {
                setCurrentUserId(record.id);
                setIsRightSideBarVisible(true);
                setIsViewMode(false);
              }}>
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="confirm-text p-2"
              to="#"
              onClick={() => handleDeleteUser(record.id)}
              title="Delete">
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const handleDeleteUser = (userId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteUser(userId); // Call API with userId
          Swal.fire("Deleted!", "The user has been deleted.", "success");
          loadUsers(); // Re-fetch the user list
        } catch (error) {
          Swal.fire("Error!", "Failed to delete the user.", "error");
        }
      }
    });
  };

  // Data transform for the table
  const transformData = (users) =>
    users?.map((user) => ({
      ...user,
      key: user.id,
    }));

  // Search logic
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    if (!query) {
      setFilteredUsers(users);
      return;
    }
    setFilteredUsers(
      users.filter(
        (user) =>
          user.username?.toLowerCase().includes(query) ||
          user.email?.toLowerCase().includes(query) ||
          user.role?.toLowerCase().includes(query)
      )
    );
  };

  // Tooltips for buttons
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="collapse-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  return (
    <div>
      <div
        style={{
          width: isRightSideBarVisible
            ? `calc(100% - ${sidebarWidth}px)`
            : "100%",
          transition: "width 0.3s ease-in-out",
        }}>
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>User Access List</h4>
              <h6>Manage users, roles, and permissions</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <div className="search-set">
              <div className="search-input">
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control form-control-sm formsearch"
                  value={searchQuery}
                  onChange={handleSearch}
                />
                <Link to="#" className="btn btn-searchset">
                  <i data-feather="search" className="feather-search" />
                </Link>
              </div>
            </div>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={renderRefreshTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={loadUsers}>
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}>
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <button
              className="btn btn-added"
              onClick={() => {
                setCurrentUserId(null);
                setIsRightSideBarVisible(true);
              }}>
              <PlusCircle className="me-2 iconsize" />
              Add New User
            </button>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={transformData(filteredUsers)}
                loading={loading}
              />
            </div>
          </div>
        </div>
      </div>
      <EditPermission
        isVisible={isRightSideBarVisible}
        onClose={() => {
          setIsRightSideBarVisible(false);
          loadUsers();
          setIsViewMode(false);
        }}
        userId={currentUserId}
        fetchUsers={loadUsers}
        onResize={(w) => setSidebarWidth(w || 0)}
        ref={sidebarRef}
        availableRoles={["admin", "user"]}
        isViewMode={isViewMode}
        isNewUser={true}
        resetFormTrigger={resetFormTrigger}
      />
    </div>
  );
};

export default UsersList;
